export default __webpack_public_path__ + "static/media/pk.bf870999.png";